import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/migration/many/user.migration.many.mutation.gql"
import type {
  UserMigrateManyMutation,
  UserMigrateManyMutationVariables,
} from "@/v2-backoffice-client/user/migration/many/__types__/user.migration.many.mutation"

type Options = MutationHookOptions<
  UserMigrateManyMutation,
  UserMigrateManyMutationVariables
>

// Each outcome carries the full updated user (normalized-cache refresh of
// MigrationStatus everywhere) plus a per-user Error when that user's send
// failed — the mutation itself only errors batch-wide.
export function useUserMigrateManyMutation(options?: Options) {
  return useMutation<UserMigrateManyMutation, UserMigrateManyMutationVariables>(
    mutation,
    options,
  )
}
